import { loadTemplate } from 'core-components/helpers/lazyLoad'

export const loadTemplateData = async (value: unknown) => {
  const [path, name] = `${value}`.split(':')
  const data = (await loadTemplate(path)) as object
  if (data[name]) {
    const needInvoke = typeof data[name] === 'function' && name.startsWith('get')
    return needInvoke ? await data[name]() : data[name]
  } else if (value) {
    console.error(`TableAdapter: Wrong path ${value}`)
  }
}
